import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { StatisticsFiltersListenerEffect } from '../effects/statistics-filters-listener.effect';
import {
  addPagination,
  resetPagination,
  setAppId,
} from '../store/slices/statistics.slice';

export const statisticsFiltersListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  statisticsFiltersListener.startListening({
    matcher: isAnyOf(addPagination, resetPagination, setAppId),
    effect: StatisticsFiltersListenerEffect,
  });
